import React from 'react';

import {
  Button, Row, Col,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Input, UncontrolledTooltip,
  FormGroup, Label
} from 'reactstrap';

import TreeViewNode from './TreeViewNode';
import useLinks from './useLinks';
import ParadigmaLabeledInput from '../../../../components/ParadigmaLabeledInput';
import ParadigmaAsyncSeeker from '../../../../components/ParadigmaAsyncSeeker';

import './styles.css';

const Links = ({ nav }) => {
  const {
    state,
    setState,
    toggle,
    confirm,
    setActiveItem,
    addNewNode,
    delNode,
    updateActiveItem,
  } = useLinks();

  return (
    <React.Fragment>
      <li className="nav-item cursor-pointer"><a onClick={toggle} className="nav-link" aria-current="page"><i className={nav.icon}></i>{nav.name}</a></li>
      <Modal isOpen={state.showModal} toggle={toggle} className="modal-primary modal-xl modal-links">
        <ModalHeader toggle={toggle}>Links</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={7} className="card card-body mh-100 m-0">
              {
                state.links.length == 0
                  ? "No hay Links"
                  : <ul className="px-0" onDragStart={(target) => console.log(target)} onDragOver={(evt) => evt.preventDefault()} onDragStop={(target) => console.log(target)}>
                    {
                      state.links.map((item) => (
                        <TreeViewNode
                          active_id={state.active_item != null ? state.active_item.id : 0}
                          setActiveItem={(item) => setActiveItem(item)}
                          key={`link-${item.id}`}
                          item={item}
                          root={false}
                          del={(item, fullDel) => delNode(item, fullDel)}
                          add={(father) => addNewNode(father)}
                        />
                      ))
                    }
                  </ul>
              }
            </Col>
            <Col>
              {
                state.categorias.length > 0 &&
                <Row>
                  <Col className="text-right">
                    <Button color="info" id="UncontrolledTooltipRootBtn" className="rounded" onClick={addNewNode}><i className="fa fa-plus" aria-hidden="true"></i></Button>
                    <UncontrolledTooltip placement="bottom" target="UncontrolledTooltipRootBtn">
                      Crear Menu Raiz
                    </UncontrolledTooltip>
                  </Col>
                </Row>
              }
              <Row>
                <Col>
                  <FormGroup>
                    <ParadigmaLabeledInput
                      label="Nombre"
                      md={[3, 9]}
                      placeholder="Nombre"
                      disabled={!!!state.active_item}
                      value={state.active_item ? state.active_item.Nombre : ""}
                      onChange={(evt) => updateActiveItem('Nombre', evt.target.value)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ParadigmaLabeledInput
                      label="Categoria"
                      md={[3, 9]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          multiselect={false}
                          optionDefault={state.categorias}
                          value={state.active_item ? state.active_item.Categoria_id : []}
                          disabled={!!!state.active_item}
                          displayField="fullName"
                          valueField="code"
                          onChange={data => updateActiveItem('Categoria_id', data ? data.code : null)}
                        />
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <ParadigmaLabeledInput
                      label="Grupos"
                      md={[3, 9]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          multiselect={true}
                          optionDefault={state.grupos}
                          value={state.active_item ? state.active_item.Grupos_ids : []}
                          displayField="Nombre"
                          disabled={!!!state.active_item}
                          valueField="code"
                          onChange={data => updateActiveItem('Grupos_ids', data ? data.map(g => g.code) : [])}
                        />
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <ParadigmaLabeledInput
                      label="Rubros"
                      md={[3, 9]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          multiselect={true}
                          optionDefault={state.rubros}
                          disabled={!!!state.active_item}
                          value={state.active_item ? state.active_item.Rubros_ids : []}
                          displayField="Nombre"
                          valueField="code"
                          onChange={data => updateActiveItem('Rubros_ids', data ? data.map(g => g.code) : [])}
                        />
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <ParadigmaLabeledInput
                      label="Lineas"
                      md={[3, 9]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          multiselect={true}
                          disabled={!!!state.active_item}
                          optionDefault={state.lineas}
                          value={state.active_item ? state.active_item.Lineas_ids : []}
                          displayField="Nombre"
                          valueField="code"
                          onChange={data => updateActiveItem('Lineas_ids', data ? data.map(g => g.code) : [])}
                        />
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <ParadigmaLabeledInput
                      label="Marcas"
                      md={[3, 9]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          multiselect={true}
                          optionDefault={state.marcas}
                          disabled={!!!state.active_item}
                          value={state.active_item ? state.active_item.Marcas_ids : []}
                          displayField="Nombre"
                          valueField="code"
                          onChange={data => updateActiveItem('Marcas_ids', data ? data.map(g => g.code) : [])}
                        />
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={confirm} className="rounded">Guardar</Button>{" "}
          <Button color="secondary" onClick={toggle} className="rounded">Cerrar</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default Links;



// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Links/Links.js